import { useEffect } from "react";
import { useRecoilState } from "recoil";

import { AllstarModalState } from "MVVM/State/modals";
import { WelcomeSeriesGate } from "MVVM/State/welcomeSeries";
import { ModalType } from "MVVM/@types";
import { getQueryParam } from "MVVM/Utilities/QueryParam";

// Local snapshot of the sonder draft copy (workflows/welcome-series.ts
// WELCOME_M*_IN_APP) — the in-app equivalent of `bun run preview:welcome`.
// Hero images are the shipped email heroes on the media CDN.
const IMG = "https://media.allstar.gg/static/react-email/static/welcome/";

const FIXTURES: Record<
  string,
  {
    title: string;
    body: string;
    ctaLabel: string;
    ctaUrl: string;
    imageUrl: string;
  }
> = {
  m1: {
    title: "Your next clutch deserves a better clip",
    body: "Link your Steam, Riot, or Faceit account and turn your matches into share-ready clips — no recording software, zero FPS drop.",
    ctaLabel: "Link Your Account",
    ctaUrl:
      "https://allstar.gg/connectedaccounts?utm_source=in-app&utm_campaign=welcome-m1",
    imageUrl: `${IMG}hero-m1-default-v3.jpg`,
  },
  m2: {
    title: "We already found your best moments",
    body: "7 moments are ready to watch from your recent matches.",
    ctaLabel: "View Your Highlights",
    ctaUrl:
      "https://allstar.gg/u/Rubaldo?utm_source=in-app&utm_campaign=welcome-m2",
    imageUrl: `${IMG}hero-m2-v2.jpg`,
  },
  m3: {
    title: "Take Allstar everywhere",
    body: "Watch, edit, and share your moments straight from your phone with the Allstar mobile app.",
    ctaLabel: "Try The App",
    ctaUrl:
      "https://allstar.gg/appstorechooser?utm_source=in-app&utm_campaign=welcome-m3",
    imageUrl: `${IMG}hero-m3-v2.jpg`,
  },
};

/**
 * Dev-only harness: `?debugWelcomeModal=m1|m2|m3` pops the welcome companion
 * modal with fixture content — no Novu, no login, no sends. Repeatable (no
 * session guard) so copy/layout can be iterated on locally.
 */
export const WelcomeSeriesDebugTrigger = () => {
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const [, setWelcomeSeriesGate] = useRecoilState(WelcomeSeriesGate);
  const isOpen = allstarModalState.isOpen;

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;
    const fixture = FIXTURES[getQueryParam("debugWelcomeModal") || ""];
    if (!fixture || isOpen !== ModalType.None) return;

    setWelcomeSeriesGate({ active: true });
    setAllstarModalState({
      isOpen: ModalType.WelcomeSeries,
      data: { ...fixture, step: getQueryParam("debugWelcomeModal") },
      functions: { markRead: () => {} },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
